import { atom } from "jotai";
import { atomWithReset } from "jotai/utils";

// Check if browser prefers dark mode
const isBrowserDefaultDark = (): boolean =>
  typeof window !== "undefined" ? window.matchMedia("(prefers-color-scheme: dark)").matches : false;

// Theme atom
export const darkModeAtom = atom(isBrowserDefaultDark());
darkModeAtom.debugLabel = "darkModeAtom";

// Culture/Language atom
export const cultureAtom = atomWithReset<string>("en");
cultureAtom.debugLabel = "cultureAtom";

// RTL direction atom (derived from culture)
export const isRTLAtom = atom((get) => {
  const culture = get(cultureAtom);
  return culture.startsWith("ar") || culture.startsWith("he");
});
isRTLAtom.debugLabel = "isRTLAtom";

// Navigation state
export const navigationCollapsedAtom = atom(false);
navigationCollapsedAtom.debugLabel = "navigationCollapsedAtom";

// Loading state for global operations
export const globalLoadingAtom = atom(false);
globalLoadingAtom.debugLabel = "globalLoadingAtom";

// Error state for global errors
export const globalErrorAtom = atom<Error | null>(null);
globalErrorAtom.debugLabel = "globalErrorAtom";

// Notification badge count
export const unreadNotificationsAtom = atom<number>(0);
unreadNotificationsAtom.debugLabel = "unreadNotificationsAtom";

// Current wizard step (for submission wizard)
export const currentWizardStepAtom = atom<number>(1);
currentWizardStepAtom.debugLabel = "currentWizardStepAtom";
